export const ADD_INTERNAL_MARKETER_PRODUCT_ACCESS = 'ADD_INTERNAL_MARKETER_PRODUCT_ACCESS';
export type ADD_INTERNAL_MARKETER_PRODUCT_ACCESS = typeof ADD_INTERNAL_MARKETER_PRODUCT_ACCESS;

export interface AddInternalMarketerProductAccess {
    type: ADD_INTERNAL_MARKETER_PRODUCT_ACCESS;
}

export function addInternalMarketerProductAccessAction(): AddInternalMarketerProductAccess {
    return {
        type: ADD_INTERNAL_MARKETER_PRODUCT_ACCESS
    };
}
